export default class CarQuickQuote {
    constructor(vm) {
        this.vm = vm;
    }

    get(event) {
        let trackingObject = null;

        switch (event) {
            case 'quickquote-car-search-numberplate-succes':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'bil prisberegner',
                    'eventAction': '01 oplysninger søg nummerplade succes',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            case 'quickquote-car-search-numberplate-error':
                trackingObject = {
                    'event': 'track-event',
                    'eventCategory': 'bil prisberegner',
                    'eventAction': '01 oplysninger søg nummerplade error',
                    'eventLabel': '',
                    'eventValue': '0',
                    'eventNoninteraction': true,
                    'data': null
                };
                break;

            default:
                trackingObject = {};
        }

        return trackingObject;
    }
}
